export enum Pages {
  Listing = 'listing',
  Physicians = 'physicians',
  Profile = 'profile',
  Booking = 'booking',
  Confirmation = 'confirmation',
}

export enum RouteSegments {
  Specialty = 'specialty',
  Locations = 'locations',
}
